import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-bucket",
  "use": "icon-file-bucket-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file-bucket\"><path d=\"M326.4 460.1H928l-82.3 324c-5.8 23-26.6 39.1-50.3 39.1H149.9c-28.6 0-51.9-23.2-51.9-51.9V252.6c0-28.6 23.2-51.9 51.9-51.9H413l105 103.7h291.8c14.3 0 25.9 11.6 25.9 25.9v77.8h-527L203.4 563.9h52.7l70.3-103.8z\" fill=\"#ffd100\" p-id=\"7769\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol